import React, { Component } from 'react'
import { string, array, number, func } from 'prop-types'
import { connect } from 'react-redux'
import SameSupportCluster from './SameSupportCluster'
import SameLocationCluster from './SameLocationCluster'
import RegularCluster from './RegularCluster'
import { allEqual, allEqualDistance } from '../MapUtils'
import { updateInfobox } from '../../../store/Actions/MapActions'

class SingleCluster extends Component {
  handleUpdateInfobox = (coordinates, signs, type) => {
    const { updateInfobox } = this.props
    updateInfobox({
      coordinates: coordinates,
      signs: signs,
      sign: null,
      type: type,
    })
  }

  render() {
    const clusterKeys = this.props.leaves(50, 0, true).map(sign => sign.key)
    const clusterSigns = this.props.signs.filter(sign =>
      clusterKeys.includes(sign.properties.id.toString())
    )
    return allEqual(clusterSigns) && allEqualDistance(clusterSigns) ? (
      <SameSupportCluster
        coordinates={this.props.coordinates}
        category={this.props.category}
        theme={this.props.theme}
        signs={clusterSigns}
        clusterColor={this.props.clusterColor}
        handleUpdateInfobox={this.handleUpdateInfobox}
      />
    ) : allEqual(clusterSigns) && !allEqualDistance(clusterSigns) ? (
      <SameLocationCluster
        coordinates={this.props.coordinates}
        category={this.props.category}
        theme={this.props.theme}
        signs={clusterSigns}
        clusterColor={this.props.clusterColor}
        handleUpdateInfobox={this.handleUpdateInfobox}
      />
    ) : (
      <RegularCluster
        coordinates={this.props.coordinates}
        category={this.props.category}
        clusterColor={this.props.clusterColor}
        theme={this.props.theme}
        pointCount={this.props.pointCount}
      />
    )
  }
}

SingleCluster.propTypes = {
  coordinates: array.isRequired,
  signs: array.isRequired,
  theme: string.isRequired,
  pointCount: number.isRequired,
  category: string.isRequired,
  leaves: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  updateInfobox: value => dispatch(updateInfobox(value)),
})

export default connect(
  null,
  mapDispatchToProps
)(SingleCluster)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SingleCluster.jsx